import { render } from "./FashionView.vue?vue&type=template&id=7c717eb9&scoped=true"
import script from "./FashionView.vue?vue&type=script&lang=js"
export * from "./FashionView.vue?vue&type=script&lang=js"

import "./FashionView.vue?vue&type=style&index=0&id=7c717eb9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c717eb9"]])

export default __exports__